import React from 'react'
import Helmet from 'react-helmet'
interface Seotype {
  title?: string
  description?: string
}

const SEO = ({
  title = 'Dashboard',
  description = 'Save, Invest and Earn',
}: Seotype) => {
  return (
    <Helmet>
      <title>F&K Savings | {title} </title>
      <meta name="description" content={description} />
    </Helmet>
  )
}

export default SEO
